import { useEffect, useState } from "react";

import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import dayjs from "dayjs";

import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { ReactComponent as ExpandMoreIcon } from "../../icons/ExpandMore24.svg";

import Link from "@mui/material/Link";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import HandleEmptyField from "../../components/HandleEmptyField";

import { doService } from "../../services/ServiceHelper";
import { getTeacherScores } from "../../services/ReportService";
import { showDropInput, showToast } from "../../components/ATPDialogs";
import TableRowNoResults from "../../components/TableRowNoResults";
import {
  StripedTableCell,
  StripedTableRow,
} from "../../components/StripedTable";

import { updateScoreValue, updateScoreComment } from "../../services/ScoreService";
import AccordionTitle from "../../components/AccordionTitle";
import InlineEditableText from "../../components/InlineEditableText";

const ScoreHistory = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);

  const [_studentScores, setStudentScores] = useState([]);
  const [_doRefresh, setDoRefresh] = useState(false);

  useEffect(() => {
    initReport();
  }, []);

  const initReport = () => {
    setShowProgress(true);
    doService(getTeacherScores(_school, _jwt), (results) => {
      setStudentScores(results.data.studentScores);
      setShowProgress(false);
    });
  };

  const handleScoreSelect = async (score) => {
    const result = await showDropInput("Select Score Value", score.scoreValue);

    if (!result.isConfirmed) {
      return;
    }

    const newScoreValue = result.value;
    setShowProgress(true);
    doService(
      updateScoreValue(_school, _jwt, score.eid, newScoreValue),
      (results) => {
        setShowProgress(false);
        showToast("S", "Score Updated.");
        initReport();
      },
    );
  };

  const doRefreshScores = () => {
    showToast("S", "Scores will Refresh every 30 seconds");

    if (!_doRefresh) {
      setDoRefresh(true);
      setInterval(() => {
        initReport();
      }, 30000);
    }
  };

  const updateComment = (score, value) => {

    setShowProgress(true);
    doService(
      updateScoreComment(_school, _jwt, score.eid, value),
      (results) => {
        setShowProgress(false);
        showToast("S", "Score Updated.");
        initReport();
      },
    );
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="My Score History" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Button
          sx={{ mb: 1, mt: 2 }}
          variant="contained"
          onClick={doRefreshScores}
        >
          Refresh Scores
        </Button>

        <Accordion disableGutters sx={{ boxShadow: 1, p: 0, mt: 2 }} expanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordionTitle"
          >
            <AccordionTitle
              text={`Student Scores (${_studentScores.length})`}
            />
          </AccordionSummary>
          <AccordionDetails>
            <Table size="small">
              <TableHead>
                <StripedTableRow>
                  <StripedTableCell align="center">Date</StripedTableCell>
                  <StripedTableCell>Student Name</StripedTableCell>
                  <StripedTableCell>Category</StripedTableCell>
                  <StripedTableCell align="center">Score</StripedTableCell>
                  <StripedTableCell>Comment</StripedTableCell>
                </StripedTableRow>
              </TableHead>
              <TableBody>
                <TableRowNoResults data={_studentScores} />
                {_studentScores.map((score) => (
                  <StripedTableRow>
                    <StripedTableCell align="center">
                      {dayjs(score.scoreDate).format("MM/DD")}
                    </StripedTableCell>
                    <StripedTableCell>
                      {score.last_name}, {score.first_name}
                    </StripedTableCell>
                    <StripedTableCell>
                      <HandleEmptyField text={score.catName} />
                    </StripedTableCell>
                    <StripedTableCell align="center">
                      <Link
                        sx={{
                          cursor: "pointer",
                        }}
                        onClick={() => handleScoreSelect(score)}
                      >
                        {score.scoreValue}
                      </Link>
                    </StripedTableCell>
                    <StripedTableCell>
                      <InlineEditableText
                        value={score.comment}
                        onChange={(value) => updateComment(score, value)}
                      />
                    </StripedTableCell>
                  </StripedTableRow>
                ))}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
      </Container>
    </>
  );
};

export default ScoreHistory;
